(function () {
  function setActive(root, key) {
    root.querySelectorAll('[data-sh-mobile-jump]').forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-sh-mobile-jump') === key);
    });
  }

  function getScrollParent(el) {
    var node = el.parentElement;
    while (node) {
      if (/(auto|scroll)/.test(getComputedStyle(node).overflowY)) return node;
      node = node.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function isVisible(el) {
    return el.offsetParent !== null;
  }

  function initMobileModels(root) {
    // Control and the v2-wcf/v2-ren layout share the same
    // data-sh-mobile-section keys ("studios"/"adus") since only one
    // set is ever visible at a time (see nav-shared.css). Filter to
    // the visible set so jump-pills/scroll-spy never target the
    // hidden one.
    var sections = Array.prototype.filter.call(root.querySelectorAll('[data-sh-mobile-section]'), isVisible);
    if (!sections.length) return;

    var scrollParent = getScrollParent(root);

    root.querySelectorAll('[data-sh-mobile-jump]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.getAttribute('data-sh-mobile-jump');
        var candidates = root.querySelectorAll('[data-sh-mobile-section="' + key + '"]');
        var target = Array.prototype.filter.call(candidates, isVisible)[0];
        if (!target) return;

        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActive(root, key);
      });
    });

    scrollParent.addEventListener('scroll', function () {
      var activeKey = 'studios';
      var parentTop = scrollParent.getBoundingClientRect().top;

      sections.forEach(function (section) {
        if (section.getBoundingClientRect().top - parentTop <= 28) {
          activeKey = section.getAttribute('data-sh-mobile-section');
        }
      });

      setActive(root, activeKey);
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sh-mobile-models]').forEach(initMobileModels);
  });
})();
